let _ = t => t,
  _t,
  _t2,
  _t3,
  _t4,
  _t5,
  _t6,
  _t7,
  _t8,
  _t9;
import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { EERIE } from 'HubStyleTokens/colors';
import UIImage from 'UIComponents/image/UIImage';
import Small from 'UIComponents/elements/Small';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIGrid from 'UIComponents/grid/UIGrid';
import UIGridItem from 'UIComponents/grid/UIGridItem';
// @ts-expect-error ts-migrate(2307) jpg import
import GYASI_BLOB from 'bender-url!pricing-pages-ui/img/peopleBlobs/gyasi.jpg';
// @ts-expect-error ts-migrate(2307) jpg import
import COMBINED_BLOB from 'bender-url!pricing-pages-ui/img/peopleBlobs/combined.jpg';
import breakpoint from 'pricing-pages-ui/constants/Breakpoints';
import { H2 } from 'UIComponents/elements/headings';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Title = styled(H2).withConfig({
  displayName: "CustomerSupport__Title",
  componentId: "sc-1d13xy0-0"
})(["font-weight:bold;line-height:44px;"]);
export const CustomerSupportContainer = styled.div.withConfig({
  displayName: "CustomerSupport__CustomerSupportContainer",
  componentId: "sc-1d13xy0-1"
})(["z-index:1;display:flex;flex-direction:row;align-items:center;width:100%;max-width:1200px;margin:0 auto;margin-top:40px;", " ", ";"], breakpoint.tabletPortrait(_t || (_t = _`
    padding: 0 3%;
  `)), breakpoint.sd(_t2 || (_t2 = _`
    margin-top: 70px;
    margin-bottom: 20px;
    padding-left: 3%;
  `)));
const WordWrapper = styled.div.withConfig({
  displayName: "CustomerSupport__WordWrapper",
  componentId: "sc-1d13xy0-2"
})(["margin-left:auto;padding-left:3%;", ";", ";"], breakpoint.sd(_t3 || (_t3 = _`
    width: 65%;
    margin-top: 0;
  `)), breakpoint.tabletPortrait(_t4 || (_t4 = _`
    width: 100%;
    padding-left: 0;
  `)));
const CustomerSupportMicroCopy = styled(Small).withConfig({
  displayName: "CustomerSupport__CustomerSupportMicroCopy",
  componentId: "sc-1d13xy0-3"
})(["text-transform:uppercase;font-weight:500;"]);
const IconsWrapper = styled(UIGrid).withConfig({
  displayName: "CustomerSupport__IconsWrapper",
  componentId: "sc-1d13xy0-4"
})(["text-align:center;margin-top:49px;margin-right:0 !important;margin-left:0 !important;", ";"], breakpoint.phone(_t5 || (_t5 = _`
    flex-direction: column;
    > div {
      display: flex;
      flex-direction: row-reverse;
      width: 100%;
      max-width: 100%;
      justify-content: flex-end;
      padding: 0;
      margin-bottom: 16px;
    }
    h5 {
      font-size: 1em;
      margin-left: 1em;
      text-align: left;
    }
  `)));
const DesktopImage = styled(UIImage).withConfig({
  displayName: "CustomerSupport__DesktopImage",
  componentId: "sc-1d13xy0-5"
})(["", ""], breakpoint.sd(_t6 || (_t6 = _`
    display: none !important;
  `)));
const MobileImage = styled(UIImage).withConfig({
  displayName: "CustomerSupport__MobileImage",
  componentId: "sc-1d13xy0-6"
})(["display:none !important;", " ", ";", ""], breakpoint.sd(_t7 || (_t7 = _`
    display: block !important;
  `)), breakpoint.tablet(_t8 || (_t8 = _`
    margin-left: -6%;
  `)), breakpoint.tabletPortrait(_t9 || (_t9 = _`
    display: none !important;
  `)));
function CustomerSupport({
  className
}) {
  return /*#__PURE__*/_jsxs(CustomerSupportContainer, {
    "data-selenium-id": "customer-support-container",
    className: className,
    children: [/*#__PURE__*/_jsx(DesktopImage, {
      src: COMBINED_BLOB,
      width: 510,
      height: 703
    }), /*#__PURE__*/_jsx(MobileImage, {
      src: GYASI_BLOB,
      width: 280,
      height: 337
    }), /*#__PURE__*/_jsxs(WordWrapper, {
      children: [/*#__PURE__*/_jsx(CustomerSupportMicroCopy, {
        use: "help",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "customerSupport.title"
        })
      }), /*#__PURE__*/_jsx(Title, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "customerSupport.subtitle"
        })
      }), /*#__PURE__*/_jsx("div", {
        className: "m-bottom-8",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "customerSupport.description"
        })
      }), /*#__PURE__*/_jsxs(IconsWrapper, {
        children: [/*#__PURE__*/_jsxs(UIGridItem, {
          size: {
            xs: 4
          },
          children: [/*#__PURE__*/_jsx("h5", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "customerSupport.phoneAndEmail"
            })
          }), /*#__PURE__*/_jsx(UIIcon, {
            color: EERIE,
            name: "calling",
            size: 28
          })]
        }), /*#__PURE__*/_jsxs(UIGridItem, {
          size: {
            xs: 4
          },
          children: [/*#__PURE__*/_jsx("h5", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "customerSupport.documentation"
            })
          }), /*#__PURE__*/_jsx(UIIcon, {
            color: EERIE,
            name: "blog",
            size: 28
          })]
        }), /*#__PURE__*/_jsxs(UIGridItem, {
          size: {
            xs: 4
          },
          children: [/*#__PURE__*/_jsx("h5", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "customerSupport.community"
            })
          }), /*#__PURE__*/_jsx(UIIcon, {
            color: EERIE,
            name: "lists",
            size: 28
          })]
        })]
      })]
    })]
  });
}
export default CustomerSupport;